import moment from "moment";

const cardsStore = {
    namespaced: true,
    state: {
        participantId: null,
        cards: [],
        dependentCards: [],
    },
    actions: {
        async load(context, data) {
            // console.log("x-cards load data:", data);
            if(!data.participantId) return;
            if(context.state.participantId == data.participantId && !data.force) return;

            var participantCards = await romeApi.get(`/participant/${data.participantId}/card`);
            var filteredParticipantCards = participantCards.filter(card => hasCorrectDateOrStatus(card));
            
            var dependentCards = await romeApi.get(`/participant/${data.participantId}/card/dependents`);
            var filteredDependentCards = dependentCards.filter(card => hasCorrectDateOrStatus(card));

            var cards = filteredParticipantCards.concat(filteredDependentCards);
            
            cards.forEach(card => { card.summary = getCardText(card); });

            context.commit("setParticipant", data.participantId);
            context.commit("setCards", cards);
            context.commit("setDependentCards", filteredDependentCards);
        },
        async issueCard({ dispatch, state }, data) {
            // console.log("x-cards issueCard data:", data);          
            let card = await romeApi.post(`/participant/${data.participantId}/card/issue`, { mailTo: data.mailTo });
            if(card)
            { 
                dispatch("load", { participantId: state.participantId, force: true });
                await dispatch("participant/loadAAID", { participantId: state.participantId}, {root:true});
                await dispatch("dependents/load", { participantId: state.participantId, force:true}, {root:true});
            }
        },
        async replaceCard({ dispatch, state }, data) {
            // console.log("x-cards replaceCard data: ", data);
            let card = await romeApi.post(`/participant/${data.participantId}/card/${data.cardId}/replace`, { mailTo: data.mailTo });
            if(card) dispatch("load", { participantId: state.participantId, force: true });
        },
        async cancelCard({ dispatch, state }, data) {
            // console.log("x-cards cancelCard data: ", data);
            let res = await romeApi.post(`/participant/${data.participantId}/card/${data.cardId}/cancel`);
            if(res && res.success) 
            dispatch("load", { participantId: state.participantId, force: true });
        },
    },
    mutations: {
        setParticipant(state, participantId) {
            state.participantId = participantId;
        },
        setCards(state, cards) {
            state.cards = cards;
            // console.log("x-cards setCards cards:", cards.map(x => x.firstName + ": " + x.summary));
        },
        setDependentCards(state, dependentCards) {
            state.dependentCards = dependentCards;
        }
    },
}

function getCardText(card) {
    var date = new Date();
        date.setHours(0,0,0,0);

        var expirationDate = card.expireDate? Date.parse(card.expireDate) : null;
        var futureExpiration = expirationDate && moment(expirationDate).isAfter(date);

        var text = '';

        if(!card || !card.cardId) {
            text = "Not Issued"
        }
        else if(!card.cardNumber) {
            text = 'New card issued ' + moment(card.issueDate).format("L") + ' - Pending card number';
        }
        else if (card.statusId == cardStatus.active || card.statusId == cardStatus.new){
            text = card.expireDate && futureExpiration
                ? setCardText('Active Card ',card, true)          
                : setCardText('Card ', card, true);
        }
        else if (card.statusId == cardStatus.tempInactive){
            text = setCardText('Temp Inactive ',card, true);
        }
        else if (card.statusId == cardStatus.permInactive || card.statusId == cardStatus.lostStolen){
        
            if (futureExpiration || !expirationDate){
                text = setCardText('Replaced Card ', card, false);
            } else {
                text = setCardText('Expired Card ', card, false);
            }
        }
        else if (card.statusId == cardStatus.inSyncWithWca){
            text = setCardText('Card in migration ', card, true);
        }
        else
        {
            text += card.issueDate ? (' Issued ' + moment(card.issueDate).format("L")) : "";
            text += card.expireDate ? (' Expires ' + moment(card.expireDate).format("L")): "";
        }

        function setCardText(text, card, useExpirationText){
            
            var newText = text + card.cardNumber + ' Issued ' + moment(card.issueDate).format("L");

            if(useExpirationText){
                var date = new Date();
                date.setHours(0,0,0,0);
            
                var expirationDate = card.expireDate? Date.parse(card.expireDate) : null;
                var expiresInFuture = expirationDate && moment(expirationDate).isSameOrAfter(date);
                
                newText += expiresInFuture ? ', Expires ' + moment(card.expireDate).format("L") : '';
                newText += !expiresInFuture && expirationDate ? ', Expired ' + moment(card.expireDate).format("L") : '';
            }
            return newText;          
        }

    return text;
}

function hasCorrectDateOrStatus(card) {
    var date = new Date();
    date.setFullYear(date.getFullYear() - 2);
    date.setHours(0,0,0,0);
    
    var useCard = moment(card.issueDate).isSameOrAfter(date);
    
    if(!useCard){
        useCard = card.statusId == cardStatus.new 
            || card.statusId == cardStatus.active 
            || card.statusId == cardStatus.tempInactive 
            || card.statusId == cardStatus.inSyncWithWca;
    }

    return useCard;
}

const cardStatus = {
    new: 1,
    active: 2,
    tempInactive: 3,
    permInactive: 4,
    lostStolen: 5,
    inSyncWithWca: 200,
}

export default cardsStore;


// WEBPACK FOOTER //
// ./src/participant/x-cards.js